<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          CHO THUÊ VÀ BÀN GIAO THIẾT BỊ THANH TOÁN THẺ
        </b>
      </p>
      <p class="txt-center">
        (PLTTB:
        <mark>{{ codeAppendixRents }}</mark
        >TTB/VIMO-....... )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán số
            <mark>{{
              dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
            }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <!-- <mark v-if="dataAppendix.dateSignDTO">{{
                    dataAppendix.dateSignDTO | formatDate
                }}</mark>
                <mark v-else-if="dataAppendix.createdDateDTO">{{
                    dataAppendix.createdDateDTO | formatDate
                }}</mark>
                <mark v-else-if="dataContract.effectiveFromDTO">{{
                    dataContract.effectiveFromDTO | formatDate
                }}</mark> -->
        <mark>{{ currentDate | formatDate }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD: <b>{{ dataContract.saleInfoRes.name ? dataContract.saleInfoRes.name : '' }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{ dataContract.saleInfoRes.mobile ? dataContract.saleInfoRes.mobile : '' }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>

      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}, {{ customerInfo.district }},
            {{ customerInfo.city }}
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Hai bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>

      <ol class="form-style1">
        <li>
          <h1>THÔNG TIN THIẾT BỊ CHO THUÊ</h1>
          <div>
            Bên A đồng ý cho Bên B thuê thiết bị (viết tắt là “TB”) đọc thẻ của Bên A, thiết bị là
            hàng mới 100%, chưa qua sử dụng. Cụ thể như sau:
          </div>
          <div><i>(Vui lòng chọn loại thiết bị theo nhu cầu tương ứng)</i></div>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th>Đánh dấu X</th>
                  <th>Tên thiết bị đầy đủ</th>
                  <th>Tên rút gọn</th>
                  <th>Tên viết tắt</th>
                  <th>Số lượng</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-for="(item, index) in deviceMposListContent" :key="index">
                  <td>{{ item.quantity ? 'X' : '' }}</td>
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.shortName }}</td>
                  <td>{{ item.quantity > 0 ? item.quantity : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>CHÍNH SÁCH CHO THUÊ THIẾT BỊ</h1>
          <ol>
            <li>
              <span class="text-bold">Mức đặt cọc & thời gian khấu hao thiết bị</span>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th class="text-center"><b>Loại thiết bị</b></th>
                      <th class="text-center"><b>Giá bán (VNĐ)</b></th>
                      <th class="text-center"><b>Mức đặt cọc (VNĐ)</b></th>
                      <th class="text-center"><b>Thời gian khấu hao (Tháng)</b></th>
                      <th class="text-center"><b>Chi phí thuê/TB/tháng (VNĐ)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td class="text-center">Tingbox01</td>
                      <td class="text-center">600.000</td>
                      <td class="text-center">700.000</td>
                      <td class="text-center">6</td>
                      <td class="text-center">100.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Tingbox02</td>
                      <td class="text-center">600.000</td>
                      <td class="text-center">700.000</td>
                      <td class="text-center">6</td>
                      <td class="text-center">120.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">TingboxS1</td>
                      <td class="text-center">500.000</td>
                      <td class="text-center">500.000</td>
                      <td class="text-center">6</td>
                      <td class="text-center">80.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">PR02</td>
                      <td class="text-center">1.500.000</td>
                      <td class="text-center">500.000</td>
                      <td class="text-center">12</td>
                      <td class="text-center">125.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N31</td>
                      <td class="text-center">2.490.000</td>
                      <td class="text-center">1.000.000</td>
                      <td class="text-center">16</td>
                      <td class="text-center">150.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Mini SmartPOS</td>
                      <td class="text-center">2.750.000</td>
                      <td class="text-center">1.000.000</td>
                      <td class="text-center">18</td>
                      <td class="text-center">150.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N33</td>
                      <td class="text-center">3.500.000</td>
                      <td class="text-center">1.200.000</td>
                      <td class="text-center">20</td>
                      <td class="text-center">180.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">SmartPOS Pro</td>
                      <td class="text-center">4.990.000</td>
                      <td class="text-center">1.500.000</td>
                      <td class="text-center">24</td>
                      <td class="text-center">220.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">mPOS Pro</td>
                      <td class="text-center">2.000.000</td>
                      <td class="text-center">1.000.000</td>
                      <td class="text-center">12</td>
                      <td class="text-center">160.000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-bold">Lưu ý: Giá trên đã bao gồm VAT</div>
              <p>
                - Tương ứng với số lượng thiết bị Bên B đồng ý thuê của Bên A được nêu tại Điều 1 –
                Phụ lục này, tổng số tiền Bên B cần đặt cọc cho Bên A là:
                <mark
                  ><b>{{ appendixDeposit ? appendixDeposit : 0 | fomatCurrency }}</b></mark
                >
                <span
                  >(Bằng chữ:
                  <mark>
                    <b>
                      {{ appendixDeposit ? appendixDeposit : 0 | formatPriceToText }} Việt Nam Đồng
                    </b> </mark
                  >).
                </span>
              </p>
              <p>
                - Nếu bên B thuê thiết bị của bên A với thời gian thuê dưới 03 tháng kể từ ngày ký
                phụ lục hợp đồng này thì bên B sẽ không được hoàn trả khoản đặt cọc thuê thiết bị
                này
              </p>
              <p>
                - Đối với dòng thiết bị Tingbox thì mỗi seri thiết bị BẮT BUỘC sử dụng DUY NHẤT 01
                user mobile.
              </p>
            </li>
            <li>
              <span class="text-bold">Chi phí thuê thiết bị</span>
              <div v-if="this.typePolicy === 'TOTAL'">
                <p>
                  Hàng tháng, chi phí thuê thiết bị Bên B cần trả cho Bên A sẽ dựa trên tổng doanh
                  số giao dịch phát sinh THỰC TẾ so với mức tổng doanh số giao dịch TIÊU CHUẨN theo
                  yêu cầu trên mỗi thiết bị mà Bên A cho Bên B thuê theo phụ lục này trong một kỳ
                  kinh doanh (từ ngày 25 tháng trước tới hết 24 của tháng đối soát), cụ thể:
                </p>
                <p>
                  Gọi X là tổng doanh số giao dịch các thiết bị THỰC TẾ đạt được, A là tổng doanh số
                  giao dịch TIÊU CHUẨN yêu cầu phát sinh qua tổng các thiết bị Bên B thuê của Bên A.
                </p>
                <p>Theo đó, A được tính như sau:</p>
                <div class="text-center"><b>A = B x C</b></div>
                <p>Trong đó:</p>
                <p>
                  <span style="font-size: 20px; color: #000000"><i class="bx bx-check"></i></span>
                  A: Tổng doanh số giao dịch <b>TIÊU CHUẨN</b> yêu cầu phát sinh qua tổng thiết bị
                  thuê (<i>Theo từng dòng thiết bị</i>)
                </p>
                <p>
                  <span style="font-size: 20px; color: #000000"><i class="bx bx-check"></i></span>
                  B: Tổng số lượng thiết bị thuê
                </p>
                <p>
                  <span style="font-size: 20px; color: #000000"><i class="bx bx-check"></i></span>
                  C: Doanh số giao dịch TIÊU CHUẨN/ 01 TB/ Tháng được quy định như sau:
                </p>
              </div>
              <p v-if="this.typePolicy === 'ODD'">
                - Hàng tháng, chi phí thuê thiết bị Bên B cần trả cho Bên A sẽ dựa trên tổng doanh
                số giao dịch phát sinh thực tế trên mỗi thiết bị mà Bên A cho Bên B thuê theo phụ
                lục này trong một kỳ kinh doanh (từ ngày 25 tháng trước tới hết 24 của tháng đối
                soát), cụ thể:
              </p>

              <div v-if="this.typePolicy === 'TOTAL'">
                <div class="table-responsive">
                  <table>
                    <thead>
                      <tr class="bg-head">
                        <th class="text-center"><b>Loại thiết bị</b></th>
                        <th class="text-center">
                          <b>Doanh số giao dịch TIÊU CHUẨN/ 01 TB/ Tháng</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center" v-for="(device, dIdx) in data" :key="'std-' + dIdx">
                        <td class="text-center">
                          {{ device.displayName ? device.displayName : '' }}
                        </td>
                        <template v-if="device.priceList && device.priceList.length > 0">
                          <template v-for="(price, index) in device.priceList">
                            <td
                              class="text-center"
                              v-if="device.priceList.length - 1 === index"
                              :key="'stdp-' + index"
                            >
                              {{ price.from | transformNumber }}
                            </td>
                          </template>
                        </template>
                        <td v-else></td>
                      </tr>
                      <!-- <tr class="text-center">
                                            <td class="text-center">PR02</td>
                                            <td class="text-center">150.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">N31</td>
                                            <td class="text-center">150.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">Mini SmartPOS</td>
                                            <td class="text-center">220.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">N33</td>
                                            <td class="text-center">170.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">SmartPOS Pro</td>
                                            <td class="text-center">300.000.000</td>
                                        </tr> -->
                    </tbody>
                  </table>
                </div>

                <p>
                  - Nếu X > A và các thiết bị Bên B thuê của Bên A có doanh số giao dịch thực tế
                  phát sinh đều đạt mức doanh số yêu cầu tối thiểu/TB/tháng dưới đây thì tất cả
                  thiết bị Bên B thuê của Bên A được miễn phí thuê:
                </p>
                <div class="table-responsive">
                  <table>
                    <thead>
                      <tr class="bg-head">
                        <th class="text-center"><b>Loại thiết bị</b></th>
                        <th class="text-center">
                          <b>Doanh số giao dịch tối thiểu/ 01 TB/ Tháng</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center" v-for="(device, d2Idx) in data" :key="'min-' + d2Idx">
                        <td class="text-center">
                          {{ device.displayName ? device.displayName : '' }}
                        </td>
                        <td class="text-center">{{ device.minimumSales | transformNumber }}</td>
                      </tr>
                      <!-- <tr class="text-center">
                                            <td class="text-center">PR02</td>
                                            <td class="text-center">30.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">N31</td>
                                            <td class="text-center">30.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">Mini SmartPOS</td>
                                            <td class="text-center">30.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">N33</td>
                                            <td class="text-center">30.000.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center">SmartPOS Pro</td>
                                            <td class="text-center">30.000.000</td>
                                        </tr> -->
                    </tbody>
                  </table>
                </div>
                <p>
                  - Nếu X &lt;= A, hoặc X>A nhưng ít nhất một trong các thiết bị Bên B thuê của Bên
                  A có doanh số giao dịch thực tế phát sinh không đạt mức doanh số yêu cầu tối
                  thiểu/TB/tháng nêu trên thì phí thuê Bên B phải trả cho Bên A sẽ được tính theo
                  mức doanh số thực tế đạt được của từng thiết bị theo quy định dưới đây:
                </p>
              </div>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th class="text-center"><b>Loại thiết bị</b></th>
                      <th class="text-center"><b>Doanh số / 01 TB / Tháng (VNĐ)</b></th>
                      <th class="text-center"><b>Phí thuê / 01 TB / Tháng (VNĐ)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(device, d3Idx) in data">
                      <template v-if="device.priceList && device.priceList.length > 0">
                        <tr
                          class="text-center"
                          v-for="(price, index) in device.priceList"
                          :key="'row-' + d3Idx + '-' + index"
                        >
                          <td class="text-center" rowspan="3" v-if="index === 0">
                            {{ device.displayName ? device.displayName : '' }}
                          </td>
                          <td
                            class="text-center"
                            v-if="(price.from === 0 || !price.from) && price.to > 0"
                          >
                            Dưới {{ price.to | transformNumber }}
                          </td>
                          <td class="text-center" v-else-if="price.from > 0 && price.to > 0">
                            Từ {{ price.from | transformNumber }} đến dưới
                            {{ price.to | transformNumber }}
                          </td>
                          <td class="text-center" v-else-if="price.from > 0 && !price.to">
                            Từ {{ price.from | transformNumber }} trở lên
                          </td>
                          <td class="text-center" v-else>Miễn phí</td>
                          <td class="text-center" v-if="price.price && price.price > 0">
                            {{ price.price | transformNumber }}
                          </td>
                          <td class="text-center" v-else>Miễn phí</td>
                        </tr>
                      </template>
                    </template>

                    <!-- <tr class="text-center">
                                            <td class="text-center" rowspan="3">PR02</td>
                                            <td class="text-center">Dưới 50.000.000</td>
                                            <td class="text-center">125.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 50.000.000 đến dưới 150.000.000</td>
                                            <td class="text-center">60.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 150.000.000 trở lên</td>
                                            <td class="text-center">Miễn phí</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center" rowspan="3">N31</td>
                                            <td class="text-center">Dưới 100.000.000</td>
                                            <td class="text-center">150.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 100.000.000 đến dưới 150.000.000</td>
                                            <td class="text-center">100.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 150.000.000 trở lên</td>
                                            <td class="text-center">Miễn phí</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center" rowspan="3">Mini SmartPOS</td>
                                            <td class="text-center">Dưới 100.000.000</td>
                                            <td class="text-center">150.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 100.000.000 đến dưới 220.000.000</td>
                                            <td class="text-center">150.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 220.000.000 trở lên</td>
                                            <td class="text-center">Miễn phí</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center" rowspan="3">N33</td>
                                            <td class="text-center">Dưới 80.000.000</td>
                                            <td class="text-center">180.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 80.000.000 đến dưới 170.000.000</td>
                                            <td class="text-center">120.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 170.000.000 trở lên</td>
                                            <td class="text-center">Miễn phí</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center" rowspan="3">SmartPOS Pro</td>
                                            <td class="text-center">Dưới 200.000.000</td>
                                            <td class="text-center">220.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 200.000.000 đến dưới 300.000.000</td>
                                            <td class="text-center">180.000</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td class="text-center"></td>
                                            <td class="text-center">Từ 300.000.000 trở lên</td>
                                            <td class="text-center">Miễn phí</td>
                                        </tr> -->
                  </tbody>
                </table>
              </div>
              <div>
                <span class="txt-bold">Ví dụ: </span>
                <i v-if="this.typePolicy === 'ODD'"
                  >Nếu Merchant thuê thiết bị Tingbox vào kỳ kinh doanh tháng 05/2024, doanh thu đạt
                  từ 30 triệu đồng đến dưới 70 triệu đồng/ 01 thiết bị thì phí thuê thiết bị đó cho
                  kỳ kinh doanh tháng 05/2024 là 50.000 VNĐ</i
                >
                <ul class="form-style2" v-if="this.typePolicy === 'TOTAL'">
                  <li>
                    Vào kì kinh doanh tháng 05/2024, Bên B thuê của Bên A 10 thiết bị SmartPOS Pro,
                    tổng doanh số giao dịch TIÊU CHUẨN yêu cầu phát sinh qua tổng thiết bị Bên B
                    thuê của Bên A là: 300.000.000 X 10 = 3.000.000.000 VNĐ
                  </li>
                  <li>
                    Nếu cả 10 thiết bị nêu trên có doanh số giao dịch phát sinh thực tế đều đạt mức
                    từ 30.000.000 VNĐ/TB trở lên, và tổng doanh số giao dịch thực tế của Bên B trên
                    tất cả các thiết bị đó đạt mức 4.000.000.000 VNĐ, Bên B được miễn phí thuê 10
                    thiết bị nêu trên.
                  </li>
                  <li>
                    Nếu trong 10 thiết bị nêu trên, có 03 thiết bị có doanh số thực tế là:
                    350.000.000 VNĐ/ TB; 1 thiết bị có doanh số mức 200.000.000 VNĐ, 6 thiết bị còn
                    lại đạt mức 500.000.000 VNĐ /TB, Bên B cần thanh toán chi phí thuê thiết bị cho
                    Bên A với số tiền: 180.000 VNĐ
                  </li>
                  <li>
                    Nếu trong 10 thiết bị nêu trên, có 03 thiết bị có doanh số thực tế là:
                    120.000.000 VNĐ/ TB;3 thiết bị có doanh số mức 250.000.000 VNĐ, 4 thiết bị còn
                    lại đạt mức 350.000.000 VNĐ /TB, Bên B cần thanh toán chi phí thuê thiết bị cho
                    Bên A với số tiền:220.000 VNĐ * 3 + 180.000 VNĐ *3 = 1.200.000 VNĐ
                  </li>
                </ul>
              </div>
              <p v-if="this.typePolicy === 'ODD'">
                <span class="txt-bold">Lưu ý: </span
                ><i
                  >Đối với giao dịch QR tĩnh thì tính tổng doanh số giao dịch của Merchant phát sinh
                  trong kỳ kinh doanh và chia đều cho số lượng thiết bị đang hoạt động trong kỳ kinh
                  doanh đó.</i
                >
              </p>
            </li>
            <li>
              <span class="text-bold">Thời hạn đối soát; thanh toán & xuất hóa đơn</span>
              <ul class="form-style2">
                <li>
                  Kỳ kinh doanh: Gọi T là tháng đối soát, kỳ kinh doanh được tính từ ngày 25 tháng
                  T-1 đến ngày 24 tháng T.
                </li>
                <li>
                  Thời gian bắt đầu tính phí thuê cho thiết bị sẽ áp dụng tính từ kỳ kinh doanh tiếp
                  theo kể từ ngày kích hoạt thiết bị thuê của bên B.
                </li>
                <li>
                  Trong vòng 03 (ba) ngày làm việc kể từ khi kết thúc kỳ kinh doanh, Bên A gửi đối
                  soát về doanh số giao dịch thanh toán đã phát sinh của thiết bị thuê Bên B trên hệ
                  thống của Bên A và chi phí thuê thiết bị tương ứng cần phải trả (nếu có) trong
                  tháng T qua email. Sau 2 ngày làm việc tiếp theo, Bên B kiểm tra số liệu và xác
                  nhận qua Email về dữ liệu đối soát giữa hai Bên.
                </li>
                <li>
                  <p>
                    Trong vòng 03 (ba) ngày làm việc kể từ ngày Bên B xác nhận đối soát, Bên B cần
                    thanh toán cho Bên A chi phí thuê thiết bị của tháng T (nếu có) bằng hình thức
                    chuyển khoản ngân hàng đến số tài khoản của Bên A, cụ thể như sau:
                  </p>
                  <br />
                  <div class="table-responsive">
                    <table>
                      <tr>
                        <td>Loại tài khoản</td>
                        <td><b>VND</b></td>
                      </tr>
                      <tr>
                        <td>Tên chủ tài khoản</td>
                        <td>
                          <b v-if="checkCreatedDateNganluong(dataAppendix)"
                            >Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng</b
                          >
                          <b v-else>Công ty Cổ Phần Công Nghệ Vi Mô</b>
                        </td>
                      </tr>
                      <tr>
                        <td>Số tài khoản ngân hàng</td>
                        <td>
                          <b v-if="!checkCreatedDateNganluong(dataAppendix)">11001010157634</b>
                          <b v-else>80002712524</b>
                        </td>
                      </tr>
                      <tr>
                        <td>Tại ngân hàng</td>
                        <td><b>TMCP Hàng Hải Việt Nam</b></td>
                      </tr>
                      <tr>
                        <td>Chi nhánh ngân hàng</td>
                        <td>
                          <b v-if="!checkCreatedDateNganluong(dataAppendix)"
                            >Sở GD - PGD Nam Hà Nội</b
                          >
                          <b v-else>Sở Giao dịch</b>
                        </td>
                      </tr>
                    </table>
                  </div>
                </li>
                <li>
                  Nội dung thanh toán <i>(Mô tả giao dịch)</i>:
                  <b>Mã phiếu thu</b>
                  <p>
                    <b
                      >(Mã phiếu thu này sẽ được gửi thông tin đến Bên B sau khi Hợp đồng được hoàn
                      thiện trên hệ thống của Bên A)</b
                    >
                  </p>
                </li>
                <li>
                  Sau khi nhận được phần thanh toán chi phí thuê thiết bị của Bên B, Bên A sẽ tiến
                  hành xuất hóa đơn cho Bên B theo quy định.
                </li>
              </ul>
            </li>
            <li>
              <span class="text-bold">Tình trạng thiết bị:</span>
              <p>
                Bên A bảo đảm cung cấp hàng hoá mới 100%, đúng nhãn hiệu của hãng sản xuất theo như
                Điều 1 của Phụ lục hợp đồng này, đóng gói theo tiêu chuẩn nhà sản xuất.
              </p>
              <p>
                Sản phẩm được kiểm tra, cài đặt và đảm bảo hoạt động tốt với hệ thống thanh toán thẻ
                của Bên A trước khi bàn giao cho Bên B.
              </p>
            </li>
            <li>
              <span class="text-bold">Thời gian và địa điểm bàn giao thiết bị</span>
              <ul>
                <li>
                  Tối đa 02 (hai) ngày làm việc kể từ ngày Phụ lục này được ký kết, Bên A sẽ tiến
                  hành giao thiết bị thanh toán thẻ cho Bên B tại địa điểm do Bên B quy định.
                </li>
                <li>Phụ lục này là căn cứ để theo dõi bảo hành thiết bị, đổi hoặc trả thiết bị</li>
              </ul>
            </li>
            <li>
              <span class="text-bold">Lưu ý chung</span>
              <ul>
                <li>
                  Đối với giao dịch QR tĩnh thì tính tổng doanh số giao dịch của Bên B phát sinh
                  trong kỳ kinh doanh & chia đều cho số lượng thiết bị đang hoạt động trong kỳ kinh
                  doanh đó.
                </li>
                <li>
                  Quy ước chung về thời gian bắt đầu tính phí thuê thiết bị:
                  <ol>
                    <li>
                      Kỳ kinh doanh: Gọi T là tháng đối soát, kỳ kinh doanh được tính từ ngày 25
                      tháng T-1 đến ngày 24 tháng T.
                    </li>
                    <Li
                      >Thời gian bắt đầu áp dụng Chính sách thuê thiết bị theo Phụ lục này: Tính từ
                      kỳ kinh doanh tháng T+1 kể từ ngày kích hoạt thiết bị Bên A cho Bên B thuê
                      theo Phụ lục này.</Li
                    >
                  </ol>
                </li>
                <li>
                  <b>KHÔNG</b> hỗ trợ thanh lý, chuyển nhượng thiết bị Bên A cho Bên B thuê theo Phụ
                  lục này.
                </li>
                <li>
                  Tất cả các Biên bản thu hồi, bàn giao liên quan thiết bị Bên A cho Bên B thuê theo
                  Phụ lục này đều phải triển khai và quản lý trên hệ thống My NextPay.

                  <i
                    >í dụ: Bên B kích hoạt thiết bị được Bên A cho thuê theo Phụ lục này từ ngày
                    15/5/2025, thì thời gian bắt đầu áp dụng chính sách từ ngày 25/5/2025.</i
                  >
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH VỀ TRẢ THIẾT BỊ VÀ NGHIỆM THU THIẾT BỊ HOÀN TRẢ</h1>
          <ol>
            <li>
              <span class="text-bold"
                >Thời gian hoàn trả thiết bị và nghiệm thu thiết bị cho thuê.</span
              >
              <ul>
                <li>
                  Sau 03 (ba) tháng kể từ ngày nhận bàn giao thiết bị, Bên B có quyền trả lại thiết
                  bị cho Bên A khi không có nhu cầu sử dụng.
                </li>
                <li>
                  Khi hoàn trả thiết bị, Bên B phải đảm bảo các tiêu chí về bảo hành theo điều 3.2.
                </li>
                <li>
                  Khi Bên B muốn trả lại thiết bị, cần thông báo cho Bên A bằng văn bản hoặc qua
                  Email.
                </li>
              </ul>
            </li>
          </ol>
          <ol>
            <li>
              <span class="text-bold">Điều kiện hoàn trả thiết bị:</span>
              <ul class="form-style2">
                <li>
                  Bên B hoàn trả thiết bị cho Bên A phải đảm bảo các thiết bị còn mới, không hỏng
                  hóc, không bị xước xát, không bị biến dạng.
                </li>
                <li>
                  Khi thiết bị hoàn trả phát sinh các vấn đề như: hỏng hóc do lỗi chủ quan khi sử
                  dụng; xây xước và hư hại dễ thấy; bị mất; …, Bên B phải bồi thường chi phí thiết
                  bị cho Bên A theo <b>giá trị bồi thường thiết bị</b>.
                </li>
                <li>
                  <p>
                    Để làm rõ điều kiện bồi thường trên, thì mức giá trị định giá cho thiết bị (khi
                    thiết bị hoàn trả phát sinh các vấn đề như: hỏng hóc do lỗi chủ quan khi sử
                    dụng; xây xước và hư hại dễ thấy; bị mất; …, ) được tính dựa trên thời gian khấu
                    hao và giá trị khấu hao thiết bị/ tháng. Trong đó, thời gian khấu hao thiết bị
                    và giá trị khấu hao, được xác định:
                  </p>
                  <br />
                  <div class="table-responsive">
                    <table>
                      <thead>
                        <tr class="bg-head">
                          <th class="text-center"><b>TT</b></th>
                          <th class="text-center"><b>Loại thiết bị</b></th>
                          <!-- <th class="text-center"><b>Thời gian khấu hao</b></th> -->
                          <th class="text-center"><b>Giá trị khấu hao/ tháng (VNĐ)</b></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="text-center">
                          <td class="text-center">(1)</td>
                          <td class="text-center">(2)</td>
                          <td class="text-center">(3)</td>
                          <!-- <td class="text-center">(4)</td> -->
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">01</td>
                          <td class="text-center"><b>Tingbox01</b></td>
                          <!-- <td class="text-center">6</td> -->
                          <td class="text-center">100.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">02</td>
                          <td class="text-center"><b>Tingbox02</b></td>
                          <!-- <td class="text-center">8</td> -->
                          <td class="text-center">120.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">03</td>
                          <td class="text-center"><b>TingboxS1</b></td>
                          <!-- <td class="text-center">8</td> -->
                          <td class="text-center">80.000</td>
                        </tr>

                        <tr class="text-center">
                          <td class="text-center">04</td>
                          <td class="text-center"><b>PR02</b></td>
                          <!-- <td class="text-center">12</td> -->
                          <td class="text-center">125.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">05</td>
                          <td class="text-center"><b>mPOS Pro</b></td>
                          <!-- <td class="text-center">12</td> -->
                          <td class="text-center">160.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">06</td>
                          <td class="text-center"><b>N31</b></td>
                          <!-- <td class="text-center">16</td> -->
                          <td class="text-center">150.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">07</td>
                          <td class="text-center"><b>Mini SmartPOS</b></td>
                          <!-- <td class="text-center">18</td> -->
                          <td class="text-center">150.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">08</td>
                          <td class="text-center"><b>N33</b></td>
                          <!-- <td class="text-center">20</td> -->
                          <td class="text-center">180.000</td>
                        </tr>
                        <tr class="text-center">
                          <td class="text-center">09</td>
                          <td class="text-center"><b>SmartPOS Pro</b></td>
                          <!-- <td class="text-center">24</td> -->
                          <td class="text-center">220.000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <p>Khi đó, giá trị bồi thường thiết bị:</p>
                <div class="text-center">
                  <b
                    ><i
                      >Giá tiền thiết bị bồi thường = [Giá trị khấu hao thiết bị/tháng] x [(T.G khấu
                      hao) – (Thời gian đã sử dụng)]</i
                    ></b
                  >
                </div>
                <!-- <p><i>Trong đó:</i></p>
                                <div class="text-center"><b><i>(3) Thời gian khấu hao</i></b></div>
                                <div class="text-center"><b><i>(4) Giá trị khấu hao/ tháng</i></b></div> -->
                <p>
                  - Trong trường hợp Bên B không hoàn trả đầy đủ lại sạc và hộp cho Bên A thì Bên B
                  phải đền bù cho Bên A khoản tiền: đối với sạc là: 200.000 (hai trăm nghìn) VNĐ,
                  hộp: 50.000 (năm mươi nghìn) VNĐ trong thời gian sử dụng từ 01 đến 06 tháng kể từ
                  ngày ký phụ lục hợp đồng này, từ tháng thứ 7 trở đi thì bên B sẽ không phải đền bù
                  khoản tiền sạc & hộp.
                </p>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH VỀ THU HỒI VÀ KHOÁ THIẾT BỊ TRÊN HỆ THỐNG</h1>
          <p>Bên A giữ quyền khóa thiết bị trên hệ thống trong các trường hợp sau:</p>
          <ul>
            <li>Bên B vi phạm các điều khoản trong Hợp đồng cung cấp dịch vụ đã ký với Bên A.</li>
            <li>
              Bên B có thông báo cho Bên A bằng văn bản hoặc email về việc yêu cầu ngưng sử dụng.
            </li>
          </ul>
        </li>
        <li>
          <h1>CHUYỂN QUYỀN SỞ HỮU THIẾT BỊ</h1>
          <p>
            Thiết bị Bên A cho Bên B thuê theo Phụ lục này sẽ chuyển về cho Bên B sở hữu khi Bên B
            đạt 01 (MỘT) trong 02 (HAI) điều kiện sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th class="text-center"><b>Loại thiết bị</b></th>
                  <th class="text-center">
                    <b>Doanh số tích luỹ / (kể từ thời điểm kích hoạt) / 01 TB (VNĐ) </b>
                  </th>
                  <th class="text-center">Hoặc trả phí thuê hết thời gian (Tháng)</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-for="(device, d4Idx) in data" :key="'own-' + d4Idx">
                  <td class="text-center">{{ device.displayName ? device.displayName : '' }}</td>
                  <td class="text-center">{{ device.totalSales | transformNumber }}</td>
                  <td class="text-center">{{ device.duration ?? '' }}</td>
                </tr>
                <!-- <tr class="text-center">
                                    <td class="text-center">PR02</td>
                                    <td class="text-center">1.500.000.000</td>
                                    <td class="text-center">12</td>
                                </tr>
                                <tr class="text-center">
                                    <td class="text-center">N31</td>
                                    <td class="text-center">2.500.000.000</td>
                                    <td class="text-center">16</td>
                                </tr>
                                <tr class="text-center">
                                    <td class="text-center">Mini SmartPOS</td>
                                    <td class="text-center">2.800.000.000</td>
                                    <td class="text-center">18</td>
                                </tr>
                                <tr class="text-center">
                                    <td class="text-center">N33</td>
                                    <td class="text-center">3.500.000.000</td>
                                    <td class="text-center">20</td>
                                </tr>
                                <tr class="text-center">
                                    <td class="text-center">SmartPOS Pro</td>
                                    <td class="text-center">5.000.000.000</td>
                                    <td class="text-center">24</td>
                                </tr> -->
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>THÔNG TIN THIẾT BỊ BÀN GIAO</h1>
          <p>
            Số lượng thiết bị bàn giao:
            <mark>{{ numberDeviceRent }}</mark>
            (chiếc). Thông tin chi tiết như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>Số TT</b></th>
                  <th><b>Email tài khoản</b></th>
                  <th><b>Serial thiết bị bàn giao/cho thuê</b></th>
                  <th><b>Serial thiết bị đang sử dụng</b></th>
                  <th><b>Địa chỉ cửa hàng/chi nhánh</b></th>
                  <th><b>SĐT liên hệ</b></th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in appendixRents" :key="index">
                <tr class="txt-center">
                  <td class="txt-center">{{ index + 1 }}</td>
                  <td>{{ customerInfo.email ?? '' }}</td>
                  <td>{{ item.policyCode ?? '' }}</td>
                  <td>
                    {{
                      item.deviceInfo && item.deviceInfo.serialNumber
                        ? item.deviceInfo.serialNumber
                        : ''
                    }}
                  </td>
                  <td>
                    <span>
                      {{ merchantBusinessAreasDevice[index].areaAddress }}
                      <span v-show="merchantBusinessAreasDevice[index].areaDistrict">
                        - {{ merchantBusinessAreasDevice[index].areaDistrict }}</span
                      >
                      <span v-show="merchantBusinessAreasDevice[index].areaCity">
                        - {{ merchantBusinessAreasDevice[index].areaCity }}</span
                      >
                    </span>
                  </td>
                  <td>{{ customerInfo.mobile ?? '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>TÌNH TRẠNG THIẾT BỊ BÀN GIAO</h1>
          <p>
            Tất cả các thiết bị bàn giao đã được hai bên kiểm tra là sản phẩm mới và sử dụng tốt.
          </p>
        </li>
        <li>
          <h1>NỘI DUNG BÀN GIAO VÀ NGHIỆM THU KHÁC</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>STT</b></th>
                  <th><b>NHÓM DỊCH VỤ</b></th>
                  <th><b>NỘI DUNG HƯỚNG DẪN/ BÀN GIAO</b></th>
                  <th><b>XÁC NHẬN </b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td><b>Khởi động thiết bị</b></td>
                  <td>Thao tác bật/ tắt và sạc pin cho thiết bị mới</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td rowspan="2">
                    <b>Thanh toán thẻ</b>
                  </td>
                  <td>Nhận diện Thẻ chíp/Thẻ từ/Thẻ Contactless; ATM/Debit/Credit</td>
                  <!-- <td>
                      <span style="font-size: 30px; color: #0085ff"
                        ><i class="bx bx-check"></i
                      ></span>
                    </td> -->
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>
                    Quẹt với thẻ từ / Cắm với thẻ chíp/ Chạm với thẻ Contactless/ In hoá đơn với
                    SmartPOS (nếu có giấy)
                  </td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Thanh toán thông thường/ Trả Góp 0%</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="2"><b>Thao tác sử dụng</b></td>
                  <td>Lựa chọn đúng mục thanh toán thường/ trả góp</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Lựa chọn ngân hàng và kỳ hạn</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td rowspan="3"><b>Quy trình hoàn thiện</b></td>
                  <td>Nhập thông tin hóa đơn và khách hàng (chủ thẻ)</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Theo từng quy trình của từng NH</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Các lưu ý "Maritimebank, Techcombank …"</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>6</b></td>
                  <td><b>Tài liệu hướng dẫn</b></td>
                  <td>Thông tin liên hệ các bộ phận Vận hành, Kỹ thuật</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>7</b></td>
                  <td><b>Các khoản phí</b></td>
                  <td>Phí trả góp, phí quẹt thẻ</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Kiểm tra lịch sử giao dịch / Kết toán</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="5"><b>Xác nhận giao dịch</b></td>
                  <td>Lịch sử giao dịch trong ngày/ trước đó</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Kết toán giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>Huỷ giao dịch/ Hoàn tiền giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Gửi lại hoá đơn qua email</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Đăng nhập bằng email của Merchant trên hệ thống của bên A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  import { DeviceService } from '@/services/device.service'

  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        deviceMposListHead: [],
        deviceMposListContent: [],
        devicePolicyDetail: {},
        devices: [],
        data: [],
        typePolicy: '',
        currentDate: new Date(),
        tokenCurrent: '',
      }
    },
    created() {
      const param = this.$route.query
      const { token } = this.$route.query

      if (param && token) {
        this.tokenCurrent = token
      } else {
        const tokenStorage =
          JSON.parse(localStorage.getItem('userData')) ??
          JSON.parse(localStorage.getItem('token')) ??
          ''
        this.tokenCurrent = tokenStorage.token ?? tokenStorage
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix ?? this.dataContract.lstAppendixDevices
      },

      appendixRents() {
        const appendix = this.dataAppendix
        const rents = appendix.appendixRent ?? appendix[appendix.length - 1].appendixDevice

        return rents?.deviceRents ?? []
      },
      merchantBusinessAreasDevice() {
        return this.appendixRents.map(s => {
          return (
            (this.dataAppendix.merchantBusinessAreas
              ? this.dataAppendix.merchantBusinessAreas
              : this.dataAppendix[this.dataAppendix.length - 1].merchantBusinessAreas
            ).find(z =>
              z.serials.includes(
                s.deviceInfo && s.deviceInfo.serialNumber ? s.deviceInfo.serialNumber : ''
              )
            ) ?? {}
          )
        })
      },
      appendixDeposit() {
        const appendix = this.dataAppendix
        const rents = appendix.appendixRent ?? appendix[appendix.length - 1].appendixDevice

        return rents?.depositTotal ?? []
      },
      codeAppendixRents() {
        const appendix = this.dataAppendix
        const rents = appendix.appendixRent ?? appendix[appendix.length - 1].appendixDevice
        return this.dataAppendix.code ? this.dataAppendix.code : rents.codeAppend || ''
      },
      numberDeviceRent() {
        return this.dataAppendix.numDevices
          ? this.dataAppendix.numDevices
          : this.dataContract.lstAppendixDevices[this.dataContract.lstAppendixDevices.length - 1]
              .numDevices || 0
      },
    },

    async mounted() {
      await this.getInfo()
      this.deviceMposListHead = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i === 0)
        : []
      this.deviceMposListContent = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i !== 0)
        : []

      this.deviceMposListContent.forEach(_device => {
        _device.quantity = 0
      })
      const appendix = this.appendixRents
      if (appendix.length > 0) {
        if (this.deviceMposListContent.length > 0) {
          appendix.forEach(device => {
            this.deviceMposListContent.forEach(_device => {
              if (device.deviceInfo && device.deviceInfo.name === _device.shortName) {
                if (_device.quantity !== undefined) {
                  _device.quantity += device.deviceInfo.quantity ?? 0
                } else {
                  _device.quantity = device.deviceInfo.quantity ?? 0
                }
              }
            })
          })
        }
      }
    },
    methods: {
      async getDetailPolicyDevice(id) {
        try {
          this.devicePolicyDetail = {}
          const res = await DeviceService.getDetailPolicyDevice_V2({
            ids: [id],
            token: this.tokenCurrent,
          })
          if (res.code === 1000) {
            this.devicePolicyDetail = res.data && res.data.length > 0 ? res.data[0] : {}
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
      async getInfo() {
        this.data = []
        const appendix = this.appendixRents
        if (appendix.length > 0) {
          for (let i = 0; i < appendix.length; i++) {
            if (
              appendix[i].deviceInfo &&
              appendix[i].deviceInfo.name &&
              !this.devices.includes(appendix[i].deviceInfo.name)
            ) {
              if (appendix[i].policyId) {
                await this.getDetailPolicyDevice(appendix[i].policyId)
                if (Object.keys(this.devicePolicyDetail).length > 0) {
                  this.typePolicy = this.devicePolicyDetail.type
                  this.devicePolicyDetail.displayName = appendix[i].deviceInfo.displayName
                  this.devices.push(this.devicePolicyDetail.categoryCode)
                  this.data.push(this.devicePolicyDetail)
                }
              }
            }
          }
        }
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
